module.exports = "/_next/static/images/FirstIntroduceImg-45556e9fb2662d916322076ce79d5097.png";